export const allTeamsForDropdown = [
  {
    id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
    name: 'Team Revenue',
  },
  {
    id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
    name: 'Team Outreach',
  },
  {
    id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
    name: 'Team CRM',
  },
  {
    id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
    name: 'Frontend Team',
  },
  {
    id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
    name: 'Backend Team',
  },
  {
    id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
    name: 'DevOps Team',
  },
  {
    id: '2fc1d3c5-d3b6-416d-956e-67fea7196d99',
    name: 'UI Team',
  },
  {
    id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
    name: 'UX Team',
  },
  {
    id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
    name: 'Content Team',
  },
  {
    id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
    name: 'Social Media Team',
  },
  {
    id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
    name: 'SEO Team',
  },
  {
    id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
    name: 'Growth Team',
  },
];
